var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 2.5V17.5H6.33407C4.21697 17.5 2.50073 15.7837 2.50073 13.6667V6.33333C2.50073 4.21624 4.21697 2.5 6.33407 2.5H10.0008ZM8.33408 4.16667H6.33407C5.13745 4.16667 4.1674 5.13672 4.1674 6.33333V13.6667C4.1674 14.8632 5.13745 15.8333 6.33407 15.8333H8.33408V4.16667ZM6.25073 8.33333C5.56037 8.33333 5.00073 7.77369 5.00073 7.08333C5.00073 6.39297 5.56037 5.83333 6.25073 5.83333C6.94108 5.83333 7.50073 6.39297 7.50073 7.08333C7.50073 7.77369 6.94108 8.33333 6.25073 8.33333ZM11.6674 2.5H13.6674C15.7845 2.5 17.5007 4.21624 17.5007 6.33333V13.6667C17.5007 15.7837 15.7845 17.5 13.6674 17.5H11.6674V2.5ZM14.1674 12.25C14.9958 12.25 15.6674 11.5784 15.6674 10.75C15.6674 9.92158 14.9958 9.25 14.1674 9.25C13.339 9.25 12.6674 9.92158 12.6674 10.75C12.6674 11.5784 13.339 12.25 14.1674 12.25Z",
    fill: "#061232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAccount);
export default __webpack_public_path__ + "static/media/switchAccount.0b71096867a41a1aafb858a062b44eb7.svg";
export { ForwardRef as ReactComponent };